import FormSwiftAPIClient from 'FormSwiftAPI/FormSwiftAPIClient';
import ConvertToCustomTemplateEnum from './ConvertToCustomTemplateEnum';

const formSwiftAPIClient = new FormSwiftAPIClient(window.API_URL);

export const convertToCustomTemplateFromDocumentType = (documentType, sessionId, sessionHash, includesPopups = true) => (
  async (dispatch) => {
    try {
      const response = await formSwiftAPIClient.request(
        'POST',
        `/document/${documentType}/convert-to-custom-template`,
        {
          creator_user_id: window.COOKIE.get('userid'),
          creator_user_token: window.COOKIE.get('userToken'),
          key: sessionId,
          hash: sessionHash,
          includes_popups: includesPopups,
        },
      );
      dispatch({
        type: ConvertToCustomTemplateEnum.CONVERT_TO_CUSTOM_TEMPLATE_FROM_DOCUMENT_TYPE,
        documentType,
      });
      const responseData = response.data;
      return responseData;
    } catch (e) {
      dispatch({
        type: ConvertToCustomTemplateEnum.CONVERT_TO_CUSTOM_TEMPLATE_FROM_DOCUMENT_TYPE_FAILURE,
        error: e.message,
      });
      return null;
    }
  }
);

export const convertToCustomTemplateFromShareKey = (shareKey, includesPopups = true) => (
  async (dispatch) => {
    try {
      const response = await formSwiftAPIClient.request(
        'POST',
        `/document/from-share-key/${shareKey}/convert-to-custom-template`,
        {
          shareKey,
          creator_user_id: window.COOKIE.get('userid'),
          creator_user_token: window.COOKIE.get('userToken'),
          includes_popups: includesPopups,
        },
      );
      dispatch({
        type: ConvertToCustomTemplateEnum.CONVERT_TO_CUSTOM_TEMPLATE_FROM_SHARE_KEY,
        shareKey,
      });
      const responseData = response.data;
      return responseData;
    } catch (e) {
      dispatch({
        type: ConvertToCustomTemplateEnum.CONVERT_TO_CUSTOM_TEMPLATE_FROM_SHARE_KEY_FAILURE,
        error: e.message,
      });
      return null;
    }
  }
);



// WEBPACK FOOTER //
// ./src-react/ConvertToCustomTemplate/ConvertToCustomTemplateActions.jsx